import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserRoutingModule } from './user-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UserRoutingModule
  ],
  exports:[]
})
export class UserModule { }

/**
 * Modal for Request of User Profile by Id
 */
export class MUserProfileRequest {
  id!: string;
}

 /**
 * Modal for Response of User Profile by Id
 */
export class MUserProfileResponse {
  statusCode!: number;
  message!: string;
  data: any = [MUserProfileResponseData];
  token!: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal for User profile Response Data
 */
export class MUserProfileResponseData{
  id!: string
  type_id!: number
  role_permissions_id!: string
  username!: string
  first_name!: string
  last_name!:string
  dob!: string
  phone_number!: number
  is_phone_number_verified!:string
  alternet_phone_number!: string
  email!: string
  is_email_verified!: string
  gender: any
  is_active!: boolean
  is_deleted!:boolean
  last_login_at!: string
  device_type!: string
  fcm_token!: string
  google_id!: string
  fb_id!: string
  is_subscribed!: boolean
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  userMessage!: string
  accessToken!: string
  role_pattern!:string
  age: any;
  profile_pic: any;
  skin_type: any;
  skin_Concern1: any;
  skin_Concern2: any;
  hair_json:any;
  makeup_json:any;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal for Request of Address List by userId
 */
export class MAddressListRequest {
  userId!: string;
}
 /**
 * Modal for Response of User Address List By userId
 */
 export class MAddressListResponse {
  statusCode!: number;
  message!: string;
  data: any = [MAddressListResponseData];
  token!: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for User Address List Response Data
 */
export class MAddressListResponseData{
  id!: string
  use_id!: string
  name!: string
  address_line1!: string
  address_line2!: string
  country_id!: number
  country_name!: string
  state_id!: number
  state_name!: string
  city!: string
  postal_code!: number
  contact_number1!: number
  email!: string
  latitude!: string
  longitude!: string
  is_default!: boolean
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for Request of Address By AddressId
 */
export class MAddressRequest {
  id?: string
  use_id!: string
  title!: string
  name!: string
  address_line1!: string
  address_line2!: string
  country_name?: string
  state_name?: string
  country_id!: number
  state_id!: number
  city!: string
  postal_code!:number
  contact_number1!: number
  email!: string
  is_default!: boolean
}
 /**
 * Modal for Response of Address By AddressId
 */
 export class MAddressResponse {
  statusCode!: number;
  message!: string;
  data: any = [MAddressResponseData];
  token!: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for Address By AddressId Response Data
 */
export class MAddressResponseData{
  id!: string
  use_id!: string
  title!: string
  name!: string
  address_line1!: string
  address_line2!: string
  country_id!: number
  state_id!: number
  state_name!: string
  city!: string
  postal_code!:number
  contact_number1!: number
  email!: string
  is_default!: boolean
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal for Request of Order Detail
 */
export class MOrderDetailRequest {
  take!:number
  skip!:number
  search!:string
}

 /**
 * Modal for Response of Order Detail
 */
 export class MOrderDetailResponse {
  statusCode!: number;
  message!: string;
  data: any = [MOrderDetailResponseData];
  token!: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for Order Details Response Data
 */
export class MOrderDetailResponseData{
  id!: string
  user_id!: string
  payment_id!: string
  payment_status!: string
  user_address_id!: string
  user_address!: string
  warehouse_id!: number
  order_number!: number
  order_date!: string
  order_amount!: number
  is_email_sent!: boolean
  is_sms_sent!: boolean
  order_tracking_number!: number
  order_status!: string
  is_cancled!: boolean
  is_active!: boolean
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  total_discount!: number
  total_fees!: number
  total_tax!: number
  customer_detail?:[MCustomerDetailResponseData]
  product_detail?:[MProductDetailResponseData]
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

 /**
 * Modal for Customer Details Response Data
 */
export class MCustomerDetailResponseData{
  id!: string
  type_id!: number
  user_type!: string
  role_permissions_id!: string
  first_name!: string
  last_name!: string
  dob!: string
  phone_number!: number
  is_phone_number_verified!: boolean
  email!: string
  is_email_verified!: boolean
  gender!: string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for Products Details Response Data
 */
export class MProductDetailResponseData{
   id!: number
   order_id!: string
   category_id!: number
   category!: string
   sub_category_id!: number
   sub_category!: string
   warehouse_id!: number
   brand_id!:number
   brand!:string
   name!:string
   description!: string
   additional_description!: string
   product_code!: string
   hsn!: string
   list_price!: number
   your_price!: number
   order_amount!: number
   handling_fee!: number
   sku!: string
   gender!: string
   size!: string
   color!: string
   thumbnail_img!: string
   is_suppliment!: boolean
   skin_concerns!: string
   skin_type!: string
   why!: string
   who!: string
   benifits!: string
   expiry_date!: string
   country_of_origin!: string
   key_ingridents!: string
   when_to_use_it!: string
   how_to_use_it!: string
   click_count!: string
   video_url!: string
   image1!: string
   image2!: string
   image3!: string
   image4!: string
   image5!: string
   minimum_qty!: number
   alert_threshold!: number
   imageList?:any
   discountList?:any
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal for Response of WisList List By UserId
 */
export class MWishlistResponse {
  statusCode!: number;
  message!: string;
  data!: [MWishListResponseData];
  token!: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for Products Details Response Data
 */
export class MWishListResponseData{
  productdetail! : [MProductDetailResponseData];
  id!: string
  user_id!: string
  product_id!: number
  qty!: number
  iswishlist!: boolean
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!: string
  customer_detail!:string
  product_detail!:string
 constructor(values: Object = {}) {
   Object.assign(this, values);
 }
}

/**
 * Modal for update order status request 
 */
export class MUpdateOrderStatusRequest {
  id!: string
  order_status!: string
  modified_by!: any
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

